import { Breakpoints } from '@volkswagen-onehub/components-core';
import type { BreakpointsProps } from '@/types';
import type { ConfigManager } from '@tribal-worldwide-london/fa-config';

//Corresponds to figma designs
export const tokens = {
  globalColors: {
    vLightGrey: '#EDF2F7',
    lightGrey: '#dfe4e8'
  },
};

function compareBreakpoints(a: string, b: string): number {
  return parseInt(a, 10) - parseInt(b, 10);
}

function mediaQueryTemplate(breakpoint: string, styles: string): string {
  if (breakpoint === '0') return styles;
  return `@media (min-width: ${breakpoint}px) {${styles}}`;
}

function createStylesForBreakpoints(
  config: Record<string, unknown>,
  fn: (x: unknown) => string = (x) => x as string
): string {
  return Object.keys(config)
    .sort(compareBreakpoints)
    .map((breakpoint) => mediaQueryTemplate(breakpoint, fn(config[breakpoint])))
    .join('');
}

export const jssToCss = (styles: any) => {
  if (!styles) return '';

  return Object.keys(styles)
    .map((key) => {
      const cssPropName = key.replace(/[A-Z]/g, (m) => '-' + m.toLowerCase());

      return styles[key] ? `${cssPropName}: ${styles[key]};` : '';
    })
    .join('');
};

export const convertBreakpointsToMediaQueries = <T>(
  referenceObject?: BreakpointsProps<T | string>
) => {
  if (!referenceObject) return;

  const convertedReferenceObject = Object.keys(referenceObject).reduce(
    (accumulator, breakpointKey) => {
      const valuePx = Breakpoints[breakpointKey as keyof typeof Breakpoints];

      if (!valuePx) {
        return accumulator;
      }

      return {
        ...accumulator,
        [`${valuePx}`]:
          referenceObject[
            breakpointKey as unknown as keyof BreakpointsProps<T>
          ],
      };
    },
    {}
  );

  return createStylesForBreakpoints(convertedReferenceObject, (styles) => {
    if (typeof styles === 'string') {
      return styles;
    }

    return jssToCss(styles);
  });
};

export const getImageUrl = (
  configManager: ConfigManager,
  path: string,
  baseUrl = 'apis.vwBaseUrl'
) => configManager.get(baseUrl) + path;
